import { DealerServiceBusinessService } from './../../business-services/dealer-service.service';

import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EditDealerServiceGuard  {

    constructor(
        private dealerServiceBusinessService: DealerServiceBusinessService,
        private router: Router
    ) {}

    canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
        if (this.dealerServiceBusinessService.dealerServiceDetails) {
            return true;
        }
        return this.router.createUrlTree(['/dealer-service']);
    }
}
